module.exports = __webpack_public_path__ + "img/MEDIA104.9bb197f3.jpg";